export const workScheduleRouteName = {
  index: "work-schedules.index",
};

export const workScheduleRoute = [
  {
    path: "/work-schedules",
    name: workScheduleRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "work_schedule",
      breadcrumbs: () => {
        return [{ title: "Jam Kerja" }];
      },
    },
  },
];
